<template>
  <div>
    <a-drawer
      title="更新记录"
      placement="right"
      width="800"
      :closable="false"
      @close="onClose"
      :visible="visible"
    >
      <p>数据库文件：{{ sqlDetail.name }}</p>
      <p>统计数量：总数 {{ count.log_count }} / 成功 {{ count.success_log_count }} / 失败 {{ count.fail_log_count }} </p>
      <tcg-table
        style="margin-top:20px;"
        ref="table"
        size="default"
        rowKey="log_id"
        :columns="columns"
        :data="loadData"
        bordered
      >
        <span slot="status" slot-scope="text">
          {{ text | valInDict(dict.statusDict) }}
        </span>
        <span slot="action_time" slot-scope="text, record">
          <span v-if="record.status==='SUCCESS'">{{ record.success_time }}</span>
          <span v-if="record.status==='FAIL'">{{ record.fail_time }}</span>
        </span>
        <span slot="action" slot-scope="text, record">
          <template v-if="record.status==='FAIL'">
            <a @click="openDbModal(record)">再次更新</a>
          </template>
          <template v-if="record.status==='NORMAL'">
            <a @click="openDbModal(record)">更新</a>
          </template>
          <template v-if="record.status==='SUCCESS'">
            --
          </template>
        </span>
      </tcg-table>
      <a-modal
        width="750px"
        :title="title"
        :visible="dbVisible"
        v-if="dbVisible"
        @ok="handleDbOk"
        @cancel="dbVisible = false"
        :confirmLoading="confirmLoading"
      >
        已选择SQL文件：{{ sqlDetail.name }}
        <p style="margin-top:10px;margin-bottom:10px;">更新内容：</p>
        <a-textarea v-model="sqlContent" :rows="12" />
      </a-modal>
    </a-drawer>
  </div>
</template>

<script>
import { sqlLogList, oneSyncDatabase } from '@/api/sql'
import {
  getSqlInfo
} from '@/api/tenant'
import { TcgTable } from '@/components'
import _ from 'lodash'
export default {
  components: {
    TcgTable
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    sqlDetail: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  created () {
    this.handel()
  },
  data () {
    return {
      // 编辑抽屉弹窗form-item标题样式
      labelCol: { lg: { span: 6 }, sm: { span: 5 } },
      // 编辑抽屉弹窗form-item组件样式
      wrapperCol: { lg: { span: 15 }, sm: { span: 19 } },
      // 按钮加载
      loading: false,
      dict: {
        status: []
      },
      count: {},
      // 表头
      columns: [
        {
          title: '客户名称',
          dataIndex: 'tenant_name',
          width: '250px'
        },
        {
          title: '创建时间',
          dataIndex: 'create_time',
          width: '180px'
        },
        {
          title: '执行时间',
          dataIndex: 'action_time',
          scopedSlots: { customRender: 'action_time' },
          width: '180px'
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          width: '100px'
        },
        {
          title: '操作',
          dataIndex: 'id',
          key: 'action',
          scopedSlots: { customRender: 'action' },
          width: '100px'
        }
      ],
      queryParam: {
        sql_id: this.sqlDetail.sql_id
      },
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return sqlLogList(Object.assign(parameter, this.queryParam))
          .then(res => {
            this.dict = _.get(res, 'values', {})
            this.count = _.get(res, 'count', {})
            return res
          })
      },
      dbVisible: false,
      tenantId: '',
      logId: '',
      sqlContent: '',
      confirmLoading: false,
      title: '数据库更新'
    }
  },
  methods: {
    // 抽屉关闭事件
    onClose () {
      this.$emit('hide')
    },
    openDbModal (record) {
      this.tenantId = record.tenant_id
      this.logId = record.log_id
      this.title = record.tenant_name + '-数据库更新'
      this.sqlContent = ''
      this.handleSqlChange()
      this.dbVisible = true
    },
    handleSqlChange () {
      // 获取sql文件信息
      getSqlInfo({ sql_id: this.sqlDetail.sql_id }).then(res => {
        if (_.get(res, 'code') === 200) {
          this.sqlContent = _.get(res, 'data.content', '')
        }
      })
    },
    handleDbOk () {
      const data = {
        log_id: this.logId,
        tenant_id: this.tenantId,
        sql_id: this.sqlDetail.sql_id
      }
      this.confirmLoading = true
      // console.log(data)
      oneSyncDatabase(data).then(res => {
        if (_.get(res, 'code') === 200) {
          this.$message.success('操作成功')
          this.$refs.table.refresh(true)
          this.confirmLoading = false
          this.dbVisible = false
        } else {
          // this.$message.error(res.message)
          this.confirmLoading = false
        }
      })
    }
  }
}
</script>
